import { MedicationForm } from "src/api/types";
import { Vial } from "../PrescribeModal";

export const getTotalDispenseQuantity = (
  vials: Vial[],
  weightLoss: boolean,
  quantity: number,
  form: MedicationForm
) => {
  const sum = vials.reduce(
    (accumulator, current) => accumulator + (current.dispense_quantity || 0),
    0
  );

  if (weightLoss) {
    return sum;
  }

  if (form === "dropper" || form === "topical") {
    return quantity === 3 || quantity === 1 ? 1 : 2;
  }

  return quantity;
};
